document.addEventListener('DOMContentLoaded', function () {
  function updateRecommendations() {
    // Oculta todos los bloques de recomendaciones si existen
    document.querySelectorAll('.custom-recommendations').forEach(el => el.style.display = 'none');

    // Recorre los productos del carrito
    document.querySelectorAll('.cart-item__name').forEach(el => {
      const title = el.textContent.trim().toLowerCase();

      if (title.includes('connect')) {
        const block = document.getElementById('recommendations-connect');
        if (block) block.style.display = 'block';
      }

      if (title.includes('mobile')) {
        const block = document.getElementById('recommendations-mobile');
        if (block) block.style.display = 'block';
      }

      if (title.includes('e-drive')) {
        const block = document.getElementById('recommendations-e-drive');
        if (block) block.style.display = 'block';
      }
    });
  }

  updateRecommendations();

  // Detecta cambios en cantidades o cuando se elimina un producto
  const cartForm = document.querySelector('form#cart');
  if (cartForm) {
    cartForm.addEventListener('change', () => setTimeout(updateRecommendations, 500));
    cartForm.addEventListener('click', (e) => {
      if (e.target.closest('.cart-remove-button a')) {
        setTimeout(updateRecommendations, 500);
      }
    });
  }
});

